/**
 * GST treatment for residential fee components (WS3 P3 / decision 10).
 *
 * Statutory resident contributions, the basic daily fee, and accommodation
 * (DAP/DAC) are coded `GST_FREE_RESIDENTIAL_CARE` (GST Act s 38-25).
 * Accommodation GST is UNVERIFIED for funded residential care.
 * The bed reservation fee and the higher everyday living fee stay
 * `TAX_REVIEW_REQUIRED` until a tenant records adviser advice.
 *
 * A zero component still carries its treatment. Export must ignore the code
 * when the net is zero, and must refuse a non-zero `TAX_REVIEW_REQUIRED`.
 *
 * docs/operations/clause-verifications/2026-10-14-aged-care-legislation-doh-rac-gst-treatment-advisory.md
 */

export const RESIDENTIAL_GST_TREATMENTS = [
  'GST_FREE_RESIDENTIAL_CARE',
  'TAX_REVIEW_REQUIRED',
] as const;

export type ResidentialGstTreatment = (typeof RESIDENTIAL_GST_TREATMENTS)[number];

export const RESIDENTIAL_FEE_COMPONENTS = [
  'bdf',
  'hotelling',
  'nccc',
  'mtcf',
  'itf',
  'accommodation',
  'bedReservation',
  'helf',
] as const;

export type ResidentialFeeComponent = (typeof RESIDENTIAL_FEE_COMPONENTS)[number];

export const RESIDENTIAL_COMPONENT_GST: Record<ResidentialFeeComponent, ResidentialGstTreatment> = {
  bdf: 'GST_FREE_RESIDENTIAL_CARE',
  hotelling: 'GST_FREE_RESIDENTIAL_CARE',
  nccc: 'GST_FREE_RESIDENTIAL_CARE',
  mtcf: 'GST_FREE_RESIDENTIAL_CARE',
  itf: 'GST_FREE_RESIDENTIAL_CARE',
  accommodation: 'GST_FREE_RESIDENTIAL_CARE',
  bedReservation: 'TAX_REVIEW_REQUIRED',
  helf: 'TAX_REVIEW_REQUIRED',
};

export function gstTreatmentForResidentialComponent(
  component: ResidentialFeeComponent,
): ResidentialGstTreatment {
  return RESIDENTIAL_COMPONENT_GST[component];
}
